import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { data, useLocation } from 'react-router-dom';
import ShinyText from '../Animation/ShinyText';

export default function HeroSectionComponents() {

    const Api_Url = process.env.REACT_APP_API_BASE_URL;

    const location = useLocation();
    const [title, setTitle] = useState('');
    const [descreption, setDescreption] = useState('');
    const [img, setImg] = useState(null);

    useEffect(() => {
        // نجهز اسم الصفحة من المسار
        const pagePath = location.pathname === '/' ? 'home' : location.pathname.replace('/', '');

        axios.get(`${Api_Url}/contentpage/show/page/${pagePath}`)
            .then(res => {
                setTitle(res.data.titlepage);
                setDescreption(res.data.description);
                setImg(res.data.img);

            })
            .catch(error => {
                console.error('Failed to fetch meta data:', error);
            });
    }, [location.pathname]);

    return (
        <header
            className="relative w-full h-[40vh] md:h-[45vh] lg:h-[70vh] overflow-hidden mb-10 "

        >


            {/* خلفية الصورة */}
            <div className="absolute w-full h-full inset-0">
                <img
                    src={img}
                    alt={title}
                    className="w-full h-full"
                    loading="lazy"
                />
            </div>

            {/* طبقة تغميق فوق الصورة */}
            <div className="absolute inset-0 bg-black/50 z-0"></div>

            {/* المحتوى فوق الصورة */}
            <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center pt-10 px-4 content-visibility-auto">
                <h1 className="text-white text-4xl lg:text-5xl font-bold mb-4"
                    dangerouslySetInnerHTML={{ __html: title }}
                >
                </h1>
                {/* <p
                    
                >
                    {descreption}
                </p> */}

                <p className="font-bold md:w-[70%] lg:w-[50%] 3xl:w-[30%] mx-auto mb-6 text-center">
                    <ShinyText
                        text={descreption}
                        speed={2.5}
                        color="#ffffff"
                        shineColor="#F79421"
                        direction="right"
                    />
                </p>
            </div>
        </header>
    )
}
